import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { API } from 'src/app/services/api.service';
import { AppData } from 'src/app/services/appdata.service';
import { Global } from 'src/app/services/global.service';
import { alertService } from 'src/app/services/alert-service.service';

import { data } from 'jquery';

@Component({
  selector: 'app-recompute-score',
  templateUrl: './recompute-score.component.html',
  styleUrls: ['./recompute-score.component.css']
})
export class RecomputeScoreComponent implements OnInit {

  checkInputCert: boolean = false;
  loaderCert: boolean = false;
  end_date: any = moment(new Date()).format("MMM DD, YYYY");
  scores_received: boolean = false;
  leed_id: any = "";
  scores: any;

  constructor(
    public global: Global,
    private api: API,
    private alertService: alertService,
    public appData: AppData
  ) { }

  checkInputsCert() {
    if (isNaN(this.leed_id) || this.end_date == '') {
      this.checkInputCert = false;
    }
    else {
      this.checkInputCert = true;
    }
  };

  recomputeScore() {
    this.loaderCert = true;
    this.scores_received = false;

    // this.end_date = 'Jan 10, 2023';

    var url = '/assets/LEED:' + this.leed_id + '/scores/recompute/';
    if (this.end_date != moment(new Date()).format("MMM DD, YYYY")) {

      var score_date = moment(this.end_date).format("YYYY-MM-DD");
      var selected_date: any = score_date.split('-');
      var new_date_obj = new Date(selected_date[0], parseInt(selected_date[1]) - 1, selected_date[2]);

      if (new_date_obj < new Date()) {
        var recompute_end_date = String(new_date_obj.getFullYear()) + '-' + ('0' + String(new_date_obj.getMonth() + 1)).slice(-2) + '-' + ('0' + String(new_date_obj.getDate())).slice(-2);
        url = '/assets/LEED:' + this.leed_id + '/scores/recompute/?at=' + recompute_end_date;
      }
    }

    this.api.get(url).subscribe(
      data => {
        if (data.effective_at == undefined) {
          this.loaderCert = false;
          this.alertService.alert('error', data, 5);
          return;
        }
        this.scores = data;
        Object.keys(this.scores).forEach((k) => {
          if (this.scores[k] != null && (k.indexOf("energy") > -1 || k.indexOf("water") > -1 || k.indexOf("waste") > -1 || k.indexOf("transport") > -1 || k.indexOf("human_experience") > -1 || k.indexOf("subscores") > -1)) {
            this.scores[k] = parseFloat((this.scores[k]).toFixed(2));
          }
        });
        this.loaderCert = false;
        this.scores_received = true;
      },
      error => {
        this.loaderCert = false;
        this.alertService.alert('error', 'Something went wrong. Please try again.', 5);
      }
    );
  };


  enableFdatePicker(): void {
    (<any>$('#end_date')).fdatepicker(
      {
        format: 'M dd, yyyy',
        onRender: (date: any) => {
          return date.valueOf() > new Date().valueOf() ? 'disabled' : '';
        }
      }).on('changeDate', (ev: any) => {
        this.end_date = $('#end_date').val();
      });

  }

  ngOnInit(): void {
  }

}
